import { LevelSelectModal } from '@/components/modals';
import { useGame } from '@/contexts/GameContext';
import { useSearchParams } from 'react-router-dom';

interface LevelSelectScreenProps {
  onStartLevel: (level: number) => void;
  onGoHome: () => void;
}

function LevelSelectScreen({ onStartLevel, onGoHome }: LevelSelectScreenProps) {
  const { gameState } = useGame();
  const [searchParams] = useSearchParams();
  const worldId = searchParams.get('world') || undefined;

  const handleLevelSelect = (level: number) => {
    // Sound is now handled in the LevelSelectModal, so no duplicate here
    onStartLevel(level);
  };

  return (
    <LevelSelectModal
      isOpen={true} // Always open on mobile since this IS the level select screen
      onClose={onGoHome}
      onLevelSelect={handleLevelSelect}
      currentLevel={gameState.level}
      worldId={worldId}
    />
  );
}

export default LevelSelectScreen;
